import React, { useEffect, useState } from 'react';
import { IntegrationProcessService } from '../../../Component/Api/IntegrationProcess/IntegrationProcessService';
import { DataTable } from '../../../Component/Common/Components/DataTable/DataTable';
import { ColumnSortOption } from '../../../Component/Model/Dto/ColumnSortOption';
import { Submissions } from '../../../Component/Model/Dto/VerificationAgency/IntegrationProcess/Submissions';
import { VaIntegrationStatus } from '../../../Component/Model/Enum/BEE123Enums';
import { EntriesPerPage } from '../../../Component/Model/Table/Table';
import { PendingScorecardSubmissionMapper } from './ScorecardSubmissionManagementTableMapper';
import { ConfirmationDialog } from '../../../Component/Common/Components/ConfirmationDialog';
import { toast } from 'react-toastify';
import {SubmissionApprovalModal} from "./SubmissionApprovalModal";

export const PendingSubmissionsPage = () => {

    const [entriesPerPage, setEntriesPerPage] = useState<EntriesPerPage>({ defaultValue: 10 });
    const [filteredItemsCount, setFilteredItemsCount] = useState<number>(0);
    const [totalItemsCount, setTotalItemsCount] = useState<number>(0);
    const [pageNumber, setPageNumber] = useState<number>(1);
    const [searchValue, setSearchValue] = useState<string>('');
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [scorecardSubmissionsData, setScorecardSubmissionsData] = useState<Submissions.SubmissionSearchResult[]>([])
    const [columnSortOption, setSortColumnOption] = React.useState<ColumnSortOption[]>([]);
    const [selectedSubmissionId, setSelectedSubmissionId] = React.useState(-1);
    const [showConfirmationDialog, setShowConfirmationDialog] = React.useState(false);
    const [showApprovalModal, setShowApprovalModal] = React.useState(false);
    const confirmDeleteMessage = "Are you sure you want to delete this submission?";

    const scorecardSubmissonSearchRequest: Submissions.SubmissionSearchInput = {
        pageNumber: pageNumber,
        pageSize: entriesPerPage.defaultValue!,
        searchValue: searchValue,
        columnSortOptions: columnSortOption,
        status: VaIntegrationStatus.Pending
    };

    const entriesPerPageChanged = (entriesPerPage: number) => {
        setEntriesPerPage({ defaultValue: entriesPerPage });
        setPageNumber(1);
    }
    const pageNumberChanged = (pageNumber: number) => {
        if (pageNumber !== 0) {
            setPageNumber(pageNumber);
        }
    }
    const searchValueChanged = (value: string) => {
        setSearchValue(value);
    }

    const columnSortingChanged = (sortOption: ColumnSortOption) => {
        setSortColumnOption([sortOption]);
        setPageNumber(1);
    }

    const fetchScorecardSubmission = async () => {
        setIsLoading(true);
        try {
            const response = await IntegrationProcessService.SearchSubmissions(scorecardSubmissonSearchRequest);
            setScorecardSubmissionsData(response.data.results);
            setTotalItemsCount(response.data.totalItemsCount);
            setFilteredItemsCount(response.data.filteredItemsCount);
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    }

    const handleCloseConfirmationModal = () => {
        setShowConfirmationDialog(false);
        setSelectedSubmissionId(-1);
    }

    const showDeleteConfirmationModal = (id: number) => {
        setSelectedSubmissionId(id);
        setShowConfirmationDialog(true);
    }

    const showAcceptOrRejectModal = (id: number) => {
        setSelectedSubmissionId(id);
        setShowApprovalModal(true);
    }

    const closeAcceptOrRejectModal = () => {
        setSelectedSubmissionId(-1);
        setShowApprovalModal(false);
        fetchScorecardSubmission();
    };

    const handleDelete = async () => {
        try {
            await IntegrationProcessService.DeleteSubmission(selectedSubmissionId);
            toast.success("Successfully deleted submission");
            fetchScorecardSubmission();
        } catch (error) {
            console.log(error)
        } finally {
            handleCloseConfirmationModal();
        }
    }

    useEffect(() => {
        fetchScorecardSubmission();
    }, [entriesPerPage, searchValue, pageNumber, columnSortOption]);

    const ScorecardSubmissionTableMapper = PendingScorecardSubmissionMapper(scorecardSubmissionsData, showDeleteConfirmationModal, showAcceptOrRejectModal);
    return (
        <>
            <DataTable
                table={ScorecardSubmissionTableMapper}
                entriesPerPage={entriesPerPage}
                pageNumber={pageNumber}
                filteredItemsCount={filteredItemsCount}
                totalItemsCount={totalItemsCount}
                entriesPerPageChanged={entriesPerPageChanged}
                pageNumberChanged={pageNumberChanged}
                searchValueChanged={searchValueChanged}
                isLoading={isLoading}
                manualSorting={true}
                columnSortingChanged={columnSortingChanged}
                canSearch
            ></DataTable>
            <SubmissionApprovalModal
                selectedSubmissionId={selectedSubmissionId}
                showApprovalModal={showApprovalModal}
                closeApprovalModal={closeAcceptOrRejectModal}
            />

            <ConfirmationDialog
                showDialog={showConfirmationDialog}
                handleAccept={handleDelete}
                handleCancel={handleCloseConfirmationModal}
                heading={"Confirm Delete"}
                message={confirmDeleteMessage}
            />
        </>
    )
}